/**
 * Stable key for when the cashier UI should reload categories/products
 * from the (local or remote) catalog. Used to avoid re-firing loads when
 * OfflinePos context identity churns (isSyncing, pendingCount, etc.).
 */
export function catalogUiLoadKey(input: {
  branchId: string;
  usesLocalCatalog: boolean;
  catalogReady: boolean;
  catalogRevision: number;
}): string | null {
  if (input.usesLocalCatalog && !input.catalogReady) {
    return null;
  }
  if (input.usesLocalCatalog) {
    return `${input.branchId}::rev:${input.catalogRevision}`;
  }
  return `${input.branchId}::online`;
}
